import type { Plan } from '@/core/domain';
import type { PlanRepository } from '../repositories/plan-repository';

export class GetAllPlansUseCase {
  constructor(private readonly repository: PlanRepository) {}

  async execute(): Promise<Plan[]> {
    return this.repository.getAll();
  }
}
